<style lang="less">
.mpoint{
	margin: 0 20px 24px 20px;
	background: #f7f8fb;
	padding: 30px 27px;
	.item{
		height: 40px;
		overflow: hidden;
		padding-bottom: 24px;
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		.icon{
			width: 27px;
			height: 40px;
			-webkit-box-flex: 0 0 auto; -moz-box-flex: 0 0 auto; -ms-flex: 0 0 auto; flex: 0 0 auto;
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			padding: 0 10px 0 4px;
			img{
				width: 27px;
			}
		}
		.info{
			height: 40px;
			padding: 3px;
			-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
			.title{
				height: 16px;
				overflow: hidden;
				color: #2e4276;
				font-size: 14px;
				font-weight: 500;
				padding: 3px 0;
			}
			.desc{
				height: 16px;
				line-height: 16px;
				padding-top: 2px;
				font-size: 12px;
				color: #2e4276;
				overflow: hidden;
				white-space: nowrap;
				text-overflow:ellipsis;
			}
		}
	}

}
</style>

<template>
	<!-- Main mpoint -->
	<section class="mpoint">
		<template v-for="item in feature" >
			<div class="item" v-bind:key="item.title">
				<div class="icon">
					<img :src="item.icon">
				</div>
				<div class="info">
					<div class="title">{{item.title}}</div>
					<div class="desc">{{item.desc}}</div>
				</div>
			</div>
		</template>
	</section>
</template>

<script>
	import axios from '../axios.js';
	import apis from '../apis.js';

	export default {
		data: function () {
			return {
				feature: []
			};
		},
		components: {
		},
		mounted: function () {
			this.getDetail();
		},
		methods: {
			getDetail: function () {
				let _this = this;
				axios.post(apis.server_config, {
					config_key: "feature"
				}).then(function(d) {
					console.log('server_config', d);
					_this.feature = JSON.parse(d.value.feature);
				});
			},
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/point.vue